import {call, put, select} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GetInitialPlayerCall} from "../../apis/user";
import {DEFAULT_SETTINGS, PLAYER_INITIALIZE_ERROR, PLAYER_INITIALIZE_SUCCESS} from "../../constants/PlayerConstants";
import getClient from "../../store/selectors/getClient";
import {PlayerSettingsObject, User} from "../../@types/response";
import {AVERAGE} from "../../constants/CommonConstants";

function* tryFunction() {
    const response: Record<string, any> = yield call(GetInitialPlayerCall);
    const client: User = yield select(getClient);
    const allowedAverage: number[] = response.books
    let settings: PlayerSettingsObject = Object.assign({}, DEFAULT_SETTINGS)
    settings.comparisons[AVERAGE].bookmakers = client.averages.filter(b => allowedAverage.includes(b))
    yield put({
        type: PLAYER_INITIALIZE_SUCCESS,
        payload: {...response, settings}
    });
}

export function* initializeSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction},
        failedType: PLAYER_INITIALIZE_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}